import * as sidebar from "../sidebar";
import * as pageComments from "../pagecomments";
import {SaleModel} from "../common/model/salemodel";
import {initSaleAdminPanel} from "../common/adminpanel";
import 'lib/adaptivefontsize';
import {newLogger} from "../../../core/utils/logger";

const logger = newLogger('Sale page');

export function init(options) {
	const o = {
		page: {},
		comments: [],
		...options
	};

	logger.log('init', o);

	initPage(o.page);
	pageComments.init({page: o.page, comments: o.comments});
	setTimeout(sidebar.init);
	categoriesCrop($('#saleWrapper .sale-cats'));
	setTimeout(initFontScale);

	initSaleAdminPanel('#wrapAdminPanel');

}

function initPage(page) {
	let model = new SalePage(page);
	ko.applyBindings(model, $(`#page_content`)[0]);
}

function initFontScale() {
	$('#saleWrapper').find('.sale-name-inner').adaptiveFontSize({
		done: (el) => {
			$(el).parent().css('opacity', 1);
		}
	});
}

class SalePage extends SaleModel {
	constructor(item) {
		super(item);

        $(document).on('reloadSales', () => {
            location.href = '/sale';
		});
	}
}

export function categoriesCrop($container){
	const $list = $container.find('.cats-list');
	while($container.innerWidth() < $list.innerWidth()){
		$list.find('li').last().remove();
	}
	$container.css('opacity','1');
}




// WEBPACK FOOTER //
// ./modules/blog/page/sale.js